/**
 * Resultsgate API
 * Open API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ATTR {
    ANALYSIS = 'ANALYSIS',
    CATEGORY = 'CATEGORY',
    COUNT = 'COUNT',
    COUNTRY = 'COUNTRY',
    ORDER = 'ORDER',
    ORDERITEM = 'ORDERITEM',
    RESULT = 'RESULT',
    SAMPLE = 'SAMPLE',
    SUBJECT = 'SUBJECT'
};

